import { type SanityDocument } from '@sanity/client'

import { sanityClient } from './sanityClient'

export default async function getWheelItems() {
  const wheelItems = await sanityClient.fetch<SanityDocument[]>(getQuery())
  return wheelItems
}

function getQuery() {
  return `*[_type == "wheelItem" && !(_id in path("drafts.**"))]{ 
    _id,
    key, 
    label, 
    description,
    descriptionAI,
    descriptionShort,
    }`
}
